import React from "react";
import "./Technology.scss";
import { appsIcon, pgtImg, tick } from "../../../../assets/images/images";
import PrimaryButton from "../../../../common/primaryButton";
import { useNavigate } from "react-router-dom";

const Technology = () => {
  const navigate = useNavigate();
  const navigateToPGT = () => {
    navigate("/our-technology");
  };
  const navigateToCounseling = () => {
    navigate("/genetic-counseling");
  };
  return (
    <section className="section tech-section">
      <div className="container-fluid">
        <div className="heading" data-aos="fade-up">
          <span>OUR TECHNOLOGY</span>
          <h2>Where science meets hope</h2>
        </div>
        <div className="content">
          <div className="left-content" data-aos="fade-right">
            <div className="text">
              <div className="text-heading">
                <svg
                  width="49"
                  height="49"
                  viewBox="0 0 49 49"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M41.0858 41.2168C39.2218 43.0808 37.1618 44.5738 34.9058 45.6958C32.6898 46.8011 30.3155 47.5551 27.8678 47.9308C22.9743 48.6892 17.966 47.9082 13.5358 45.6958C11.2798 44.5738 9.21981 43.0808 7.35581 41.2158C5.49081 39.3518 4.00081 37.2968 2.88481 35.0468C0.664004 30.6149 -0.120364 25.6011 0.640808 20.7028C1.01639 18.2548 1.7704 15.8801 2.87581 13.6638C3.99781 11.4088 5.49081 9.34877 7.35581 7.48377C9.21981 5.61977 11.2758 4.12977 13.5258 3.01377C15.741 1.90472 18.1166 1.15053 20.5658 0.778774C23.0018 0.398774 25.4388 0.398774 27.8758 0.778774C30.325 1.15055 32.7006 1.90474 34.9158 3.01377C37.1658 4.12977 39.2218 5.61977 41.0858 7.48377C42.9498 9.34877 44.4438 11.4088 45.5658 13.6638C46.6701 15.8766 47.4212 18.2486 47.7918 20.6938C48.1717 23.116 48.1717 25.5826 47.7918 28.0048C47.4201 30.454 46.6659 32.8296 45.5568 35.0448C44.4408 37.2948 42.9498 39.3508 41.0868 41.2148L41.0858 41.2168ZM31.1908 31.0378L33.2508 31.0288V15.3218H17.5408L17.5328 17.3818L29.7258 17.3728L14.4728 32.6268L15.9458 34.0998L31.1988 18.8468L31.1888 31.0398L31.1908 31.0378Z"
                    fill="white"
                  />
                </svg>
                <h3>PGT</h3>
                <p>
                  Preimplantation Genetic Testing to help you achieve your
                  family planning goals.{" "}
                </p>
              </div>
              <div className="footer">
                <ul>
                  <li>
                    <img src={tick} alt="tick" />
                    <p>
                      Preimplantation Genetic Testing for Aneuploidy (PGT-A)
                    </p>
                  </li>
                  <li>
                    <img src={tick} alt="tick" />
                    <p>
                      Preimplantation Genetic Testing for Monogenic Disorders
                      (PGT-M)
                    </p>
                  </li>
                  <li>
                    <img src={tick} alt="tick" />
                    <p>
                      Preimplantation Genetic Testing for Chromosomal (PGT-SR)
                    </p>
                  </li>
                </ul>
                <PrimaryButton
                  handleClick={navigateToPGT}
                  primaryBtnText="Preimplantation Genetic Testing"
                />
              </div>
            </div>
            <div className="img">
              <img src={pgtImg} alt="pgt-img" />
            </div>
          </div>
          <div className="right-content" data-aos="fade-left">
            <div className="text-heading counseling">
              <div>
                <svg
                  width="41"
                  height="41"
                  viewBox="0 0 41 41"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M34.4232 34.3885C32.8699 35.9418 31.1532 37.186 29.2732 38.121C27.4266 39.0421 25.448 39.6704 23.4082 39.9835C19.3303 40.6155 15.1568 39.9647 11.4649 38.121C9.5849 37.186 7.86824 35.9418 6.3149 34.3876C4.76074 32.8343 3.51907 31.1218 2.58907 29.2468C0.738401 25.5536 0.0847605 21.3754 0.71907 17.2935C1.03206 15.2535 1.6604 13.2745 2.58157 11.4276C3.51657 9.54847 4.76074 7.8318 6.3149 6.27764C7.86824 4.7243 9.58157 3.48264 11.4566 2.55264C13.3025 1.62843 15.2822 0.999933 17.3232 0.690137C19.3532 0.37347 21.3841 0.37347 23.4149 0.690137C25.4559 0.999946 27.4356 1.62844 29.2816 2.55264C31.1566 3.48264 32.8699 4.7243 34.4232 6.27764C35.9766 7.8318 37.2216 9.54847 38.1566 11.4276C39.0768 13.2717 39.7027 15.2484 40.0116 17.286C40.3282 19.3045 40.3282 21.36 40.0116 23.3785C39.7018 25.4195 39.0733 27.3992 38.1491 29.2451C37.2191 31.1201 35.9766 32.8335 34.4241 34.3868L34.4232 34.3885ZM26.1774 25.906L27.8941 25.8985V12.8093H14.8024L14.7957 14.526L24.9566 14.5185L12.2457 27.2301L13.4732 28.4576L26.1841 15.7468L26.1757 25.9076L26.1774 25.906Z"
                    fill="#121316"
                  />
                </svg>
                <h3>Genetic counseling</h3>
              </div>
              <img src={appsIcon} alt="img" width="100" height="100" />
              <div className="padding-right">
                <p className="para">
                  Educates individuals to make informed decisions about their
                  reproductive health and family planning.
                </p>
                <PrimaryButton
                  handleClick={navigateToCounseling}
                  primaryBtnText="Make an informed decision"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Technology;
